import Animation from 'shared/components/Animation';

const ANIMATION_PROPS = {
  spring: {
    from: { marginTop: '-2rem', opacity: 0 },
    to: { marginTop: '0rem', opacity: 1 }
  }
}

const Brand = () => (
  <img className="brand" src="/img/brand.svg" />
)

const LoginLayout = props => {
  const {
    children
  } = props;

  return (
    <Animation props={ANIMATION_PROPS}>
      <div id="welcome">
        <div className="side-header left-col">
          <Brand />
        </div>

        <div className="right-col">
          {children}
        </div>
      </div>
    </Animation>
  )

}

export default LoginLayout;
